import React from "react"
import { useState, useEffect } from "react"
import { collection, query, orderBy, onSnapshot } from "firebase/firestore"
import { db } from "@/config/firebase"
import { Product } from "@/shared/types/product"
import { normalizeProduct } from "@/shared/utils/productImages"

interface UseProductsResult {
  products: Product[]
  loading: boolean
  setProducts: React.Dispatch<React.SetStateAction<Product[]>>
}

const useProducts = (userId: string | null): UseProductsResult => {
  const [products, setProducts] = useState<Product[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!userId) {
      setProducts([])
      setLoading(false)
      return
    }

    const q = query(collection(db, "users", userId, "products"), orderBy("createdAt", "desc"))
    const unsubscribe = onSnapshot(
      q,
      snapshot => {
        setProducts(
          snapshot.docs.map(d =>
            normalizeProduct({
              id: d.id,
              ...(d.data() as Omit<Product, "id">)
            })
          )
        )
        setLoading(false)
      },
      error => {
        console.error("Error fetching products:", error)
        setLoading(false)
      }
    )

    return unsubscribe
  }, [userId])

  return { products, loading, setProducts }
}

export { useProducts }
